import {
  Box,
  IconButton,
  LinearProgress,
  Paper,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import useStyles from "./styles";

import { OpenInFullOutlined, TimelineOutlined } from "@mui/icons-material";

import LineChartComponent from "../../lineComponent";
import ModalChartHistory from "../../modalChartHistory";
import dayjs from "dayjs";
import { rangeMax } from "../../../utils/rangeMaxDate";
import { useEffect, useRef, useState } from "react";
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
dayjs.extend(utc);
dayjs.extend(timezone);
const timeZone = "America/Sao_Paulo";

export default function DataGraphComponent(params) {
  const {
    data = [],
    titleGraph,
    colorCardComponent = "red",
    loading = false,
    handleAplicarZoom = () => {},
    isZoomEnabled = false,
    formatTraffic = null,
    enableHistoryModal = true,
  } = params;

  const [openModalHistory, setOpenModalHistory] = useState(false);
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <Paper
      sx={{
        ...styles.paper,
        backgroundColor: theme.palette.background.paper,
      }}
      elevation={theme.palette.mode == "dark" ? 0 : 3}
    >
      {loading && <LinearProgress sx={styles.linearProgress} />}
      <Box sx={styles.containerComponent}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Box
              sx={{
                ...styles.containerIconCard,
                backgroundColor:
                  colorCardComponent === "orange"
                    ? theme.palette.cardGraphic.graphColor.orangeMedium
                    : colorCardComponent === "blue"
                      ? theme.palette.cardGraphic.graphColor.blueMedium
                      : theme.palette.cardGraphic.graphColor[colorCardComponent],
              }}
            >
              <TimelineOutlined
                sx={{
                  color: theme.palette.white.main,
                  fontSize: "20px",
                }}
              />
            </Box>
            <Typography
              sx={{
                ...styles.cardSubText,
                color: theme.palette.cardGraphic.graphColor[colorCardComponent],
              }}
            >
              {titleGraph}
            </Typography>
          </Box>

          {enableHistoryModal && (
            <Tooltip title="Abrir histórico ampliado">
              <IconButton
                size="small"
                onClick={() => setOpenModalHistory(true)}
                sx={{ color: theme.palette.text.secondary }}
              >
                <OpenInFullOutlined fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        <Box sx={styles.containerGraph}>
          <LineChartComponent
            data={data}
            isZoomEnabled={isZoomEnabled}
            onZoomChange={(range) => {
              // Use .unix() para interpretar o valor como segundos
              const startDate = dayjs.unix(range.start).tz(timeZone);
              const endDate = dayjs.unix(range.end).tz(timeZone);

              handleAplicarZoom(startDate, endDate);
            }}
            mainColor={theme.palette.cardGraphic.graphColor[colorCardComponent]}
            mainLineColor={
              theme.palette.cardGraphic.graphLineColor[colorCardComponent]
            }
            formatValue={formatTraffic}
            xOptions={{
              tickFormatter: (clock) =>
                dayjs.unix(clock).tz(timeZone).format("DD/MM HH:mm"),
            }}
          />
        </Box>
      </Box>

      {enableHistoryModal && (
        <ModalChartHistory
          open={openModalHistory}
          onClose={() => setOpenModalHistory(false)}
          title={titleGraph}
          icon={TimelineOutlined}
          color={colorCardComponent}
          initialData={data}
          currentValue={
            Array.isArray(data) && data.length > 0
              ? data[data.length - 1]?.value
              : null
          }
          unit={params?.unit || ""}
          formatValue={formatTraffic}
        />
      )}
    </Paper>
  );
}
